import Seo from "../components/Seo";
import PageHero from "../components/site/PageHero";
import { useReveal } from "../lib/useReveal";
import { UserRound } from "lucide-react";

export default function Trustees() {
  const ref = useReveal();
  return (
    <div ref={ref}>
      <Seo
        title="Trustees"
        path="/trustees"
        description="The trustees of Mount Moriah Relief hold responsibility for the governance, stewardship and direction of the charity."
      />
      <PageHero eyebrow="Our People" title="Trustees &amp; stewardship">
        <p>
          Our trustees carry responsibility for the direction, governance and integrity of
          Mount Moriah Relief.
        </p>
      </PageHero>

      <section className="py-24 lg:py-32">
        <div className="max-w-3xl mx-auto px-6">
          <div className="reveal bg-white border border-sandstone p-8 lg:p-12">
            <UserRound size={28} strokeWidth={1.5} className="text-gold" aria-hidden="true" />
            <h2 className="mt-6 font-serif text-2xl sm:text-3xl font-semibold text-forest">
              Trustee profiles are being finalised
            </h2>
            <p className="mt-4 text-charcoal/80 leading-relaxed">
              Biographical details of our trustees will be published on this page following
              review and approval by the board. We publish only verified information about the
              people who govern Mount Moriah Relief, and this page will be updated as soon as
              approved profiles are available.
            </p>
            <p className="mt-4 text-charcoal/80 leading-relaxed">
              In the meantime, our <a href="/governance" className="text-forest underline">Governance &amp; Transparency</a> page
              explains how the charity is directed and held accountable, and you are welcome
              to <a href="/contact" className="text-forest underline">contact us</a> with any question about our governance.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
